const setSliderCirclesAnimation = (sliderSelector, indexOfActiveSlider, index) => {
    const currentClass = {
        slide: `swiper-slide`,
        circle: `__animation`,
    };

    //const slider = document.querySelector(sliderSelector);
    let slider;
    let slides;

    //const slides = slider.querySelectorAll(`.${currentClass.slide}`);
    if (index !== undefined) {
        slider = document.querySelectorAll(sliderSelector);
        slides = slider[index].querySelectorAll(`.${currentClass.slide}`);
    } else {
        slider = document.querySelector(sliderSelector);
        slides = slider.querySelectorAll(`.${currentClass.slide}`);
    }

    const activeSlide = slides[indexOfActiveSlider];

    if (!activeSlide.classList.contains(currentClass.circle)) {
        activeSlide.classList.add(currentClass.circle);
    }
};

export {setSliderCirclesAnimation};
